import ActivityLogEvent from "../private/ActivityLogEvent";
import protoRoot from "../proto-root";
import createMessage from "./createMessage";

const name = "activityLogUpdateMessage";

function create({ eventToCreate, eventToUpdate, updateNumber }) {
  const ActivityLogUpdateMessage = protoRoot.lookupType(
    "comm.ActivityLogUpdateMessage"
  );

  const message = ActivityLogUpdateMessage.create({
    updateNumber,
    eventToCreate: ActivityLogEvent.create(eventToCreate || {}),
    eventToUpdate: ActivityLogEvent.create(eventToUpdate || {})
  });

  return createMessage({ [name]: message });
}

export default {
  create,
  name
};

// message ActivityLogUpdateMessage {
//     int32 updateNumber = 1;
//     ActivityLogEvent eventToCreate = 2;
//     ActivityLogEvent eventToUpdate = 3;

// }
